import { Entity } from '../entity';
import { OpportunityAccountLike, OpportunityContactLike, OpportunitySiteLike } from '../opportunities/opportunity';
import { OpportunityStage } from '../opportunities/opportunity.stage';
import { OpportunityViewFilters } from '../opportunities/opportunity.filters';
import { JobType } from '../tenant/job.type';
import { Allocation } from './allocation';

// view
export interface SchedulerOpportunityView {
    items: SchedulerOpportunitySummary[];
    refiners: SchedulerOpportunityRefiners;
    // sorts?: WorkOrderBoardSort[];
    refinements?: SchedulerOpportunityRefinements;
}

export interface SchedulerOpportunityViewRequest {
    /** opportunity view id */
    viewId?: string;
    filters?: OpportunityViewFilters;
    refinements?: SchedulerOpportunityRefinements;
    refiners?: boolean;
    timezone: string;
}

export interface SchedulerOpportunityRefinements extends Pick<
    Partial<OpportunityViewFilters>,
    'createdAt'
    | 'expectedClose'
    | 'search'
    | 'tags'
    | 'zones'
> {
    /** Customer */
    accounts?: Entity[];

    stages?: OpportunityStage[];
    owners?: Entity[];
    jobTypes?: Entity[];
    sources?: Entity[];
}

export const defaultSchedulerOpportunityRefinements: { [k in keyof SchedulerOpportunityRefinements]: any } = {
    search: null,
    accounts: [],
    stages: [],
    owners: [],
    tags: [],
    zones: [],
    jobTypes: [],
    sources: [],
    createdAt: null,
    expectedClose: null,
};

export interface SchedulerOpportunityRefiners {

    /** Customer */
    accounts?: Entity[];
    stages?: OpportunityStage[];
    owners: Entity[];
    createdDate: any;
    expectedClose: any;
    jobTypes: JobType[];
    tags?: Entity[];
    zones: Entity[];
    search?: string;
}


// summary
export interface SchedulerOpportunitySummary {

    _id: string;

    opportunityNumber: string;
    stage: OpportunityStage;

    account: OpportunityAccountLike;
    contact: OpportunityContactLike;
    site: OpportunitySiteLike;
    company: Entity;

    expectedClose: Date;

    createdDate?: Date;
    jobType: Entity;
    tags: Entity[];
    zones?: Entity[];
    timezone?: string;
}

export interface SchedulerOpportunityAllocations {
    summary: SchedulerOpportunitySummary;
    allocations: Allocation[];
}